import { get } from "api/Base.api";
import { INotice } from 'api/interfaces/bbs.interface';
import { IPagination } from 'api/interfaces/common.interface';

// 공지사항 목록 조회 응답 인터페이스
export interface INoticeListResponse {
    noticeList: INotice[];
    pagination: IPagination;
}

// 공지사항 상세 조회 응답 인터페이스
export interface INoticeDetailResponse {
    notice: INotice;
}

/**
 * 지망생용 공지사항 목록 조회
 * @param page 페이지 번호 (기본값: 1)
 * @returns 공지사항 목록과 페이지네이션 정보
 */
export const getNoticeList = async (page: number = 1): Promise<INoticeListResponse> => {
    const response = await get(`/student/v2/notice`, { page });
    return response;
};

/**
 * 지망생용 공지사항 상세 조회
 * @param id 공지사항 ID
 * @returns 공지사항 상세 정보
 */
export const getNoticeDetail = async (id: number): Promise<INoticeDetailResponse> => {
    const response = await get(`/student/v2/notice/${id}`);
    return response;
};
